import React, {Component} from 'react';
import Radium from 'radium';
import {Device, darkGray} from './shared.js';

class Article extends Component {
  getStyle() {
    return {
      article: {
        margin: '60px auto 0',
        padding: Device.isMobile() ? '0 30px' : null,
        maxWidth: 450,
        textAlign: 'left',
      },
      reset: {
        margin: 0,
        padding: 0,
      },
      h1: {
        color: darkGray,
        fontSize: Device.isMobile() ? 26 : 36,
        fontWeight: 700,
      },
      h2: {
        color: darkGray,
        fontFamily: '"Droid Serif", serif',
        fontSize: Device.isMobile() ? 16 : 24,
        fontStyle: 'italic',
        fontWeight: 400,
        letterSpacing: -.5,
        lineHeight: 1.4,
      },
        text: {
        color: darkGray,
        display: 'block',
        fontSize: 14,
        fontWeight: 400,
      },
      fullText: {
        height: this.state.open ? 'auto' : 0,
      },
      button: {
        background: 'none',
        border: 'none',
        color: '#ED2D15',
        fontSize: 14,
        fontWeight: 400,
        padding: 0,
        textDecoration: 'underline',
        ':hover': {
          cursor: 'pointer',
        },
        minimize: {
          display: 'inline',
          marginLeft: Device.isMobile() ? 'calc(100% - 40px)' : '100%',
          opacity: this.state.open ? 1 : 0,
          transform: 'translateX(-50%)',
        },
        readmore: {
          opacity: this.state.open ? 0 : 1,
        }
      },
      hr: {
        margin: '60px auto 0',
        position: 'relative',
        width: '30%',
      },
    };
  }

  toggleArticleState() {
    this.setState({ open: !this.state.open });
  }

  componentDidMount() {
    this.setState({ 
      open: false
    });
  }

  render() {
    const { headline, subheader, previewText } = this.props.content;
    const toggleArticleState = this.toggleArticleState.bind(this);
    const style = this.getStyle();

    const fullText = this.state.open ? this.props.content.fullText : null;

    return (
      <div style={style.article}>
        <h1 
          id={ this.props.headlineId } 
          ref="headline"
          style={[style.reset, style.h1]}>
          { headline }
        </h1>
        <h2
          style={[style.reset, style.h2]}>
          { subheader }
        </h2>
        <p
          style={[style.reset, style.text]}>
          { previewText }
        </p>
        <div
          ref="fullText"
          style={ [style.fullText, style.reset, style.text] }>
          { fullText }
        </div>
        <button
          ref="minimize"
          style={[style.button, style.button.minimize]}
          onClick={ toggleArticleState }>
          minimieren
        </button>
        <button
          ref="readmore"
          style={[style.button, style.button.readmore]}
          onClick={ toggleArticleState }>
          weiterlesen...
        </button>
        <hr style={style.hr}/>
      </div>
    );
  }
}

export default Radium(Article);


// WEBPACK FOOTER //
// ./src/modules/article.js